import { axios } from '@/libs/api.request'

export const Login = formData => {
  return axios.post('/api/login', formData)
}

export const GetUserInfo = () => {
  return axios.get('/getInfo')
}